import { createFileRoute } from "@tanstack/react-router";

import { AdjustmentPage } from "@/features/money/pages";

export const Route = createFileRoute("/_app/money/adjustments/$adjustmentId")({
  component: Adjustment,
});

function Adjustment() {
  const { adjustmentId } = Route.useParams();
  return <AdjustmentPage key={adjustmentId} adjustmentId={adjustmentId} />;
}
